import React from "react";
import HeroPages from "../components/HeroPages";
import PlaceholderImg from "../images/components/placeholder.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { capitalFirstLetter } from "../utils";
import { Box, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import Navbar from "../components/Navbar";
import { useBookingContext } from "../context/BookingContext";
import FeatureList from "../components/FeatureList";
import { useTranslation } from "react-i18next";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Navbar2 from "../components/Navbar2";

function DetailVehicle() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setModal, data, setData } = useBookingContext();
  const dekstop = useMediaQuery("(min-width:900px)");
  const tablet = useMediaQuery("(min-width:600px)");
  const phone = useMediaQuery("(max-width:600px)");
  const car = location?.state?.car;
  const prices = location?.state?.prices;
  const from = location?.state?.from;

  React.useEffect(() => {
    window.scrollTo(0, 400);
  }, []);

  if (!location.state || !car) {
    window.location.href = "/";
  }

  const specification = [
    {
      title: capitalFirstLetter(car.brands),
      icon: "fa-solid fa-tags",
    },
    {
      title: capitalFirstLetter(car.transmision),
      icon: "fa-solid fa-gears",
    },
    {
      title: capitalFirstLetter(car?.drive_system),
      icon: "fa-solid fa-car",
    },
    {
      title: capitalFirstLetter(car.color),
      icon: "fa-solid fa-droplet",
    },
  ];

  if (data?.type === "tour" && specification[2]) {
    delete specification[2];
  }

  const insuranceItems = [
    {
      icon: "fa-check-circle",
      text: t("km_unlimited") || "Kilometer Unlimited",
      included: true,
    },
    {
      icon: "fa-check-circle",
      text: t("own_risk") || "Own Risk Protection",
      included: true,
    },
    {
      icon: "fa-check-circle",
      text: t("damage_cover") || "Damage Cover",
      included: true,
    },
    {
      icon: "fa-times-circle",
      text: t("glass_tire") || "Glass & Tire Damage",
      included: false,
    },
    {
      icon: "fa-times-circle",
      text: t("interior_protect") || "Interior Protection",
      included: false,
    },
    {
      icon: "fa-times-circle",
      text: t("not_included_towing") || "Towing Service",
      included: false,
    },
  ];

  const _onSelectCar = (values) => {
    setModal(true);
    setData({ ...data, car: values });
    navigate("/select-vehicle");
  };

  return (
    <>
      <Navbar2 />
      <HeroPages name={t("detail_vehicle")} />
      <section className="detail-section">
        <Grid
          container
          style={{
            flexDirection: dekstop ? "row" : tablet ? "column-reverse" : "column-reverse",
          }}
        >
          <Grid item xs={12} sm={12} md={4}>
            <Typography fontSize={26} fontWeight={"700"} my={2}>
              {capitalFirstLetter(car?.name)}
            </Typography>
            <Stack direction={{ xs: "row", sm: "row", md: "column" }} spacing={3}>
              <Box>
                {specification?.map((item) => {
                  return (
                    <Box
                      key={item.icon}
                      sx={{
                        display: "flex",
                        width: "11rem",
                        fontSize: "16px",
                        textAlign: "start",
                        alignItems: "center",
                        fontWeight: "500",
                        mb: 1,
                      }}
                    >
                      <i className={item.icon} style={{ width: 30 }}></i>
                      <p>{item.title}</p>
                    </Box>
                  );
                })}
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={12} md={8}>
            {car?.image_urls[0] ? (
              <Carousel dynamicHeight>
                {car.image_urls.map((item, idx) => {
                  return (
                    <div key={idx}>
                      <img src={item} alt="car images" />
                    </div>
                  );
                })}
              </Carousel>
            ) : (
              <img src={PlaceholderImg} width={"100%"} alt="" />
            )}
          </Grid>
        </Grid>

        {/* Insurance Protection Section */}
        <div className="w-full px-4 py-8 md:py-12">
          <div className="max-w-6xl mx-auto">
            {/* Header */}
            <div className="mb-8 text-center md:text-left">
              <div className="flex items-center justify-center gap-3 mb-3 md:justify-start">
                <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-lg">
                  <i className="text-xl text-red-600 fa-solid fa-shield-halved"></i>
                </div>
                <h3 className="text-2xl font-bold md:text-3xl text-slate-900">
                  {t("insurances") || "Perlindungan Asuransi"}
                </h3>
              </div>
              <p className="text-sm text-slate-600 md:text-base">
                {t("insurance_subtitle") || "Lindungi perjalanan Anda dengan perlindungan komprehensif"}
              </p>
            </div>

            {/* Insurance Grid */}
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 md:gap-6">
              {insuranceItems.map((item, idx) => (
                <div
                  key={idx}
                  className={`group relative overflow-hidden rounded-xl border-2 transition-all duration-300 hover:shadow-lg ${
                    item.included
                      ? "bg-gradient-to-br from-green-50 to-emerald-50 border-green-200 hover:border-green-400 hover:scale-105"
                      : "bg-gradient-to-br from-red-50 to-rose-50 border-red-200 hover:border-red-300"
                  }`}
                >
                  {/* Background Pattern */}
                  <div className="absolute inset-0 opacity-5">
                    <div
                      className="absolute inset-0"
                      style={{
                        backgroundImage: `radial-gradient(circle, ${
                          item.included ? "#10b981" : "#ef4444"
                        } 1px, transparent 1px)`,
                        backgroundSize: "20px 20px",
                      }}
                    ></div>
                  </div>

                  <div className="relative p-5 md:p-6">
                    <div className="flex items-start gap-4">
                      {/* Icon Container */}
                      <div
                        className={`flex-shrink-0 w-14 h-14 rounded-xl flex items-center justify-center shadow-md transition-transform duration-300 group-hover:scale-110 ${
                          item.included ? "bg-white border-2 border-green-300" : "bg-white border-2 border-red-300"
                        }`}
                      >
                        <i
                          className={`fa-solid ${item.icon} text-2xl ${
                            item.included ? "text-green-600" : "text-red-600"
                          }`}
                        ></i>
                      </div>

                      {/* Text Content */}
                      <div className="flex-1 min-w-0">
                        <p
                          className={`font-semibold text-base md:text-lg leading-tight ${
                            item.included ? "text-slate-800" : "text-slate-700"
                          }`}
                        >
                          {item.text}
                        </p>
                        <div className="mt-2">
                          <span
                            className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium ${
                              item.included ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                            }`}
                          >
                            {item.included ? (
                              <>
                                <i className="fa-solid fa-circle-check"></i>
                                {t("included") || "Termasuk"}
                              </>
                            ) : (
                              <>
                                <i className="fa-solid fa-circle-xmark"></i>
                                {t("not_included") || "Tidak Termasuk"}
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Hover Border Effect */}
                  <div
                    className={`absolute bottom-0 left-0 right-0 h-1 transform origin-left scale-x-0 transition-transform duration-300 group-hover:scale-x-100 ${
                      item.included ? "bg-green-600" : "bg-red-600"
                    }`}
                  ></div>
                </div>
              ))}
            </div>

            {/* Additional Info */}
            <div className="p-6 mt-8 border-2 border-blue-200 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl">
              <div className="flex flex-col items-start gap-4 md:flex-row md:items-center">
                <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 bg-blue-600 rounded-lg">
                  <i className="text-xl text-white fa-solid fa-info"></i>
                </div>
                <div className="flex-1">
                  <h4 className="mb-2 text-base font-bold text-slate-800 md:text-lg">
                    {t("customer_service") || "Layanan Pelanggan 24/7"}
                  </h4>
                  <p className="text-sm text-slate-600 md:text-base">
                    {t("with_a_professional") || "Tim profesional kami siap membantu Anda kapan saja selama perjalanan"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FeatureList data={car?.additional_informations} />

        {from === "select-vehicle" ? (
          <>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                mt: 4,
              }}
            >
              <div onClick={() => _onSelectCar(car, prices)} className="detail-section__btn">
                <a>{t("select_this_car").toUpperCase()}</a>
              </div>
            </Box>
          </>
        ) : null}
      </section>
    </>
  );
}

export default DetailVehicle;
